import axiosInstance from '../../utils/axiosConfig';

export const FETCH_INSPECTOR_SHIFTS_REQUEST = 'FETCH_INSPECTOR_SHIFTS_REQUEST';
export const FETCH_INSPECTOR_SHIFTS_SUCCESS = 'FETCH_INSPECTOR_SHIFTS_SUCCESS';
export const FETCH_INSPECTOR_SHIFTS_FAILURE = 'FETCH_INSPECTOR_SHIFTS_FAILURE';



export const fetchInspectorShifts = () => async (dispatch) => {
    dispatch({ type: FETCH_INSPECTOR_SHIFTS_REQUEST });
    try {
        const response = await axiosInstance.get(
            `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectorShiftTimeslot/getAll`
        );
        dispatch({
            type: FETCH_INSPECTOR_SHIFTS_SUCCESS,
            payload: response.data
        });
        return response.data;
    } catch (error) {
        dispatch({
            type: FETCH_INSPECTOR_SHIFTS_FAILURE,
            payload: error.message
        });
        throw error;
    }
}; 
export const fetchInspectorShiftsWithGarage = (associatedRepairShop) => async (dispatch) => {
    if (!associatedRepairShop) {
        throw new Error('Missing associatedRepairShop in query.');
    }

    dispatch({ type: FETCH_INSPECTOR_SHIFTS_REQUEST });
    try {
        const response = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/inspectorShiftTimeslot/getByGarage`,
            { associatedRepairShop }
        );

        // Extract the shifts array from the response
        const shiftsArray = response.data.inspectorShiftTimeslot || [];

        if (!shiftsArray.length) {
            console.log('No inspectors found for the selected garage.');
        }

        dispatch({
            type: FETCH_INSPECTOR_SHIFTS_SUCCESS,
            payload: shiftsArray
        });
        return shiftsArray;
    } catch (error) {
        console.error('Error fetching inspectors:', error);
        dispatch({
            type: FETCH_INSPECTOR_SHIFTS_FAILURE,
            payload: error.message
        });
        throw error;
    }
};
